import { QRTYPE } from 'services/constants';
import { ChargeQrChipChange } from '../actions';

const createAction = name => ({
  GET_QR_SUCCESS: `${name}_GET_QR_SUCCESS`
});

export const QR = createAction('QR');

export const GetQrFilter = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: QR.GET_QR_SUCCESS,
      payload: QRTYPE
    });
    dispatch(ChargeQrChipChange(QRTYPE));
  } catch (error) {}
};
